
<lib-cdw-dialog
  data-testid="session-timeout-dialog"
  toolbarTitle="Session Timeout Warning"
  customWidth="560px"
  primaryButtonText="Stay Logged In"
  secondaryButtonText="Log Out Now"
  (primaryButtonClick)="onStayLoggedIn()"
  (secondaryButtonClick)="onLogOutNow()"
  (dismissButtonClick)="onLogOutNow()"
>
  <div class="session-timeout-body">
    <lib-cdw-message-band
      mode="error-outline"
      icon="warning"
      infoTitle="Warning!"
      [fullWidth]="true"
    >
      <span>
        Your account has been inactive for {{ idleMinutes }} minute{{
          idleMinutes === 1 ? '' : 's'
        }}. Due to inactivity, your secure session is about to expire.
        <strong>Any unsaved changes may be lost.</strong>
      </span>
    </lib-cdw-message-band>

    <div class="countdown" role="status" aria-live="polite">
      <div class="countdown-label">You will be logged out in:</div>
      <div class="countdown-value" data-testid="session-timeout-countdown">
        {{ secondsRemaining$ | async }} seconds
      </div>
      <div class="countdown-hint">Click below to keep working</div>
    </div>
  </div>
</lib-cdw-dialog>
